module.exports = __webpack_public_path__ + "static/img/icon_1.bdb0fcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/icon_1.png
// module id = UMWB
// module chunks = 49